import type { WeekHours } from '@/lib/hours';
import details from './shop-details.json';

/**
 * The regular week, Sunday first (index 0) through Saturday (6), edited by the
 * owners at /admin (content/shop.json). A close time of '00:00' is understood
 * as the end of this day, not the start of it (see sessionMinutes in
 * lib/hours.ts).
 *
 * Note: selling hot food after 23:00 requires a Late Night Refreshment licence
 * from Rushmoor Borough Council.
 */
export const WEEK_HOURS: WeekHours = details.weekHours;
